import PendoCheckbox from '../../checkbox/pendo-checkbox.vue.js';
import PendoGroupOption from './pendo-group-option.vue.js';
import PendoIconOption from './pendo-icon-option.vue.js';

var script = {
  name: 'PendoCheckboxOption',
  components: {
    PendoCheckbox,
    PendoGroupOption,
    PendoIconOption
  },
  inject: ['multiselect'],
  props: {
    option: {
      type: [Object, String],
      required: true
    },
    type: {
      type: String,
      default: 'icon',
      validator: type => ['icon', 'group'].includes(type)
    }
  },
  computed: {
    isChecked() {
      return this.multiselect.isOptionSelected(this.option);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-checkbox-option.vue2.js.map
